import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

interface WorkflowLabelConfigurationResponse {
  success: boolean;
  is_protected: boolean;
  approver_role_id: number | null;
}

export const useWorkflowLabelConfiguration = (
  labelId: number | null | undefined,
  enabled = true,
) => {
  const userToken = useUserToken();

  return useQuery<WorkflowLabelConfigurationResponse>({
    queryKey: ["workflow-label-configuration", labelId],
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.workflow_label_configuration(labelId!), {
        method: "GET",
        headers: authHeader(userToken),
      });
      return handleResponse(response);
    },
    enabled: enabled && !!labelId && !!userToken,
  });
};
